var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useI18n } from "@/shared/hooks";
import { Box } from "@gemini/core";
import { Button, Modal } from "@gemini/ui";
import { useEllipsis } from "@/hooks";
import { useGetThumbnailGalleryVariant } from "@/components/Sections/Location/hooks/useGetThumbnailGalleryVariant";
const TRIGGER = (_a) => {
    var rest = __rest(_a, []);
    const { t } = useI18n();
    return (_jsx(Button, Object.assign({ zIndex: "zIndex.4", variant: "tertiary-inverted", marginTop: "spacing.16" }, rest, { children: t("gallery.modal.description.cta") })));
};
export const SlideDescription = ({ description }) => {
    const { ref, hasButton, ellipsisStyle } = useEllipsis(4);
    const isThumbnailGalleryActivated = useGetThumbnailGalleryVariant();
    return description ? (_jsx(Box, { position: "absolute", bottom: {
            "breakpoint.base": "spacing.80",
            "breakpoint.lg": isThumbnailGalleryActivated
                ? "spacing.128"
                : "spacing.16",
        }, left: 0, width: "100%", display: "flex", justifyContent: "center", overflow: "hidden", children: _jsxs(Box, { padding: "spacing.16", backgroundColor: "color.surface.constant.blackTransparent.default", borderRadius: "radius.8", color: "unsafe_component.imageSlider.color.colorIndicator", maxWidth: "700px", width: "fit-content", margin: 0, children: [_jsx(Box, { ref: ref, as: "p", margin: 0, unsafe_style: ellipsisStyle, children: description }), hasButton && (_jsx(Modal, { isDismissable: true, trigger: TRIGGER, children: description }))] }) })) : null;
};
